/**
 * @generated SignedSource<<0271dbd1b812c906a1ed6937b0c182fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MasqueradeBarPatronFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly email?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly masquerader: {
    readonly email: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "MasqueradeBarPatronFragment_session";
};
export type MasqueradeBarPatronFragment_session$key = {
  readonly " $data"?: MasqueradeBarPatronFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"MasqueradeBarPatronFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MasqueradeBarPatronFragment_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "masquerader",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "49d1be95f310e0ca742cd3b45fb14335";

export default node;
